import { getApiBase } from "./apiConfig";
import { getAdminJwt } from "./authToken";
import { fetchAdminEventsListAndTotal, normalizeEventForDashboardRow } from "./eventsApi";
import { fetchAdminContactMessages, fetchAdminVolunteerApplications } from "./siteFormsApi";
import { fetchMediaLibrary } from "./mediaApi";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const mockRecentArticles = [
  {
    id: "a1",
    title: "Tech Giants Announce Major Layoffs",
    author: "John Smith",
    status: "published",
    views: 3200,
    date: "2024-01-29",
  },
  {
    id: "a2",
    title: "Rising Sea Levels Threaten Coastal Cities",
    author: "Jennifer Lee",
    status: "published",
    views: 1800,
    date: "2024-01-30",
  },
  {
    id: "a3",
    title: "Customer-Centric Business Models",
    author: "Sarah Johnson",
    status: "draft",
    views: 0,
    date: "2024-02-01",
  },
];

function formatStatCount(n) {
  const x = typeof n === "number" && Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
  try {
    return x.toLocaleString();
  } catch {
    return String(x);
  }
}

export async function fetchRecentArticles() {
  if (getApiBase() && getAdminJwt()) {
    const { events, total } = await fetchAdminEventsListAndTotal();
    const rows = events.map(normalizeEventForDashboardRow);
    const totalPosts =
      typeof total === "number" && Number.isFinite(total) && total >= 0 ? Math.floor(total) : rows.length;
    return { rows, totalPosts: Math.max(rows.length, totalPosts) };
  }
  await sleep(550);
  return { rows: mockRecentArticles, totalPosts: mockRecentArticles.length };
}

export async function fetchAdminDashboardBundle() {
  const [articlesResult, messages, volunteers, media] = await Promise.all([
    fetchRecentArticles().catch(() => ({ rows: [], totalPosts: 0 })),
    fetchAdminContactMessages().catch(() => []),
    fetchAdminVolunteerApplications().catch(() => []),
    fetchMediaLibrary().catch(() => []),
  ]);

  const articles = articlesResult.rows || [];
  const postsTotal =
    typeof articlesResult.totalPosts === "number" && Number.isFinite(articlesResult.totalPosts)
      ? Math.max(0, Math.floor(articlesResult.totalPosts))
      : articles.length;

  const stats = [
    {
      key: "posts",
      title: "Posts",
      value: formatStatCount(postsTotal),
      trend: "Events (all statuses)",
      trendDirection: "neutral",
    },
    {
      key: "messages",
      title: "Messages",
      value: formatStatCount(messages.length),
      trend: "Contact form",
      trendDirection: "neutral",
    },
    {
      key: "volunteers",
      title: "Volunteers",
      value: formatStatCount(volunteers.length),
      trend: "Applications",
      trendDirection: "neutral",
    },
    {
      key: "media",
      title: "Media",
      value: formatStatCount(media.length),
      trend: "Library items",
      trendDirection: "neutral",
    },
  ];

  return {
    stats,
    articles,
    messagePreview: messages.slice(0, 5),
    volunteerPreview: volunteers.slice(0, 5),
  };
}
